import { useRef, useContext, useState } from 'react';

import styles from './AddGuestsComponent.module.css'

import { GlobalContext } from "../../../contexts/globalContext";
import { ProjectDetailsContext } from '../../../contexts/projectDetailsContext';

import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import PopupBodyComponent from '../common/PopupBodyComponent';
import PopupBaseComponent from '../common/PopupBaseComponent';
import ClosePageButtonComponent from '../../commons/ClosePageButtonComponent'
import RightBodyComponent from '../common/RightBodyComponent';
import LeftBodyComponent from '../common/LeftBodyComponent';
import FooterButtonsComponent from '../common/FooterButtonsComponent';
import New_InputTextComponent from '../../keyboard/New_InputTextComponent';
import New_DropDownComponent from '../../keyboard/New_DropDownComponent';

import CountriesJson from '../../../graphics/country.json';

import membersAdd from '../../../graphics/Popups/Icon Members Add.png'

const AddGuestComponent = ({ setDisplayedParticipants, allParticipantsRef, participantsFilter, setParticipantsFilter, refreshParticipantsList}) => {

    const inputRef = useRef()
    const inputRefCountry = useRef()

    const [isOpaque, setIsOpaque] = useState(true)

    const { selectedProject, socketRef, keyboardRef, setAddGuest, currentConference, setAlertMessage, currentUser } = useContext(GlobalContext);
    const { setAddParticipants } = useContext(ProjectDetailsContext);

    function handleEmailAdd() {
        var projectId = selectedProject?._id;

        if (!projectId) {
            projectId = currentConference.project;
        }

        socketRef.current.emit("CREATE_USER_AND_ADD_TO_PROJECT", {
            projectId: projectId,
            userData: {
                "email": inputRef.current.value,
                "role": 'GUEST',
                "country": inputRefCountry.current.currentChoice?.value ? inputRefCountry.current.currentChoice.value : null,
                "creatorLocationId": currentUser?.location ? currentUser.location : null
            }
        }, (callback) => {
            if (!callback.error) {

                if (refreshParticipantsList) {
                    allParticipantsRef.current = [...allParticipantsRef.current, callback.response[0]];

                    if (participantsFilter === "ALL") {
                        setDisplayedParticipants((prevParticipants) => [
                            ...prevParticipants,
                            callback.response[0]
                        ]);
                    }

                    setParticipantsFilter('ALL');
                }
                setAddGuest(false)
                setAddParticipants(false)
                setAlertMessage({ type: "SUCCESS", message: "Member created and added to project successfully." });
            } else {
                setAlertMessage({ type: "ERROR", message: callback.message })
            }
        })

    }


    return (
        <PopupBaseComponent>
            <PopupBodyComponent style={{ width: 2040, height: 820, top: "13%" }}>
                <ClosePageButtonComponent setClose={() => setAddGuest(false)} />
                <LeftBodyComponent givenWidth="800px" image={membersAdd} title="Add guest to project" description="Guests have limited access to the project and can participate in selected conferences." />
                <RightBodyComponent>
                    <div className={styles.title}>New Guest</div>
                    <div className={styles.subTitle}>Email</div>
                    <New_InputTextComponent ref={inputRef} keyboardRef={keyboardRef} value="" placeHolder="Enter email here" styleType='POPUP' width="1000px" height="80px"
                        fontSize="40px" iconPosition="right" withDelete={true} icon={byPrefixAndName.fas["pen"]} onChange={() => {
                            if (inputRef.current?.value === "") {
                                setIsOpaque(true)
                            } else {
                                setIsOpaque(false)
                            }
                        }} />

                    <div className={styles.subTitle}>Country</div>
                    <New_DropDownComponent options={CountriesJson} ref={inputRefCountry} keyboardRef={keyboardRef} value="" placeHolder="Choose country" iconPosition="right" withDelete={true}
                        styleType='POPUP' width="1000px" height="80px" fontSize="40px" />

                    <div style={{ bottom: 130, position: "absolute" }}>
                        <FooterButtonsComponent
                            lightText={"Create"}
                            lightClick={isOpaque ? () => {} : handleEmailAdd}
                            isOpaque={isOpaque}
                            darkClick={setAddGuest}
                        />
                    </div>
                </RightBodyComponent>
            </PopupBodyComponent>

        </PopupBaseComponent>
    );

}

export default AddGuestComponent;